<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row">
          <div class="header-left">
            <img
              src="assets/svg/forecast-icon.svg"
              alt="Prospectos"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Forecast</h1>
          </div>
          <div class="header-actions">
              <button class="btn btn-round-outline" >
                <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
              </button>
              <button class="btn btn-round-outline" >
                <img class="center-svg" src="assets/svg/settings-icon.svg" />
              </button>
            
                        <button class="action-btn outline">
                            <img src="assets/svg/download-icon-org.svg" alt="Vista resumen" width="16" height="16" />
                            Descargar gráficos
                        </button>

            <button class="action-btn primary" (click)="showTableView()">
              <img
                src="assets/svg/table-icon.svg"
                alt="Ver grafico"
                width="16"
                height="16"
              />
                Ver tabla
            </button>
          </div>
        </div>

        <div
          class="header-stats mt-3"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="header-stats mt-3">
            <span>Última actualización 9/10/2025 a las 14:45</span>
          </div>
        </div>
        <div class="content-area mt-5">
            <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
            <div *ngIf="!isLoading && forecasts.length > 0"></div>

            <div class="d-grid progress-status-row mt-3 ">
                <div class="status-card-4">
                    <div class="content-card-4">
                        <div class="card-header">
                        <img src="assets/svg/report-icon-1.svg" alt="icono metas" class="card-icon" />
                        <span class="card-title">Metas</span>
                        </div>
                        <div class="card-body">
                            <b class="card-amount-bold">${{formatAmountToMillions(totales?.total_metas)}}M</b> CLP
                        </div>
                    </div>
                </div>
                <div class="status-card-4">
                    <div class="content-card-4">
                        <div class="card-header">
                        <img src="assets/svg/report-icon-1.svg" alt="icono cerradas" class="card-icon" />
                        <span class="card-title">Oportunidades cerradas</span>
                        </div>
                        <div class="card-body">
                            <b class="card-amount-bold">${{formatAmountToMillions(totales?.cerradas_ganadas)}}M</b> CLP
                        </div>
                    </div>
                </div>
                <div class="status-card-4">
                    <div class="content-card-4">
                        <div class="card-header">
                        <img src="assets/svg/report-icon-1.svg" alt="icono alta probabilidad" class="card-icon" />
                        <span class="card-title">Mejor de los casos</span>
                        </div>
                        <div class="card-body">
                            <b class="card-amount-bold">${{formatAmountToMillions(totales?.alta_probabilidad)}}M</b> CLP
                        </div>
                    </div>
                </div>
                <div class="status-card-4">
                    <div class="content-card-4">
                        <div class="card-header">
                        <img src="assets/svg/report-icon-1.svg" alt="icono baja probabilidad" class="card-icon" />
                        <span class="card-title">Oportunidades de baja probabilidad</span>
                        </div>
                        <div class="card-body">
                            <b class="card-amount-bold">${{formatAmountToMillions(totales?.baja_probabilidad)}}M</b> CLP
                        </div>
                    </div>
                </div>
                <div class="status-card-4">
                    <div class="content-card-4">
                        <div class="card-header">
                        <img src="assets/svg/report-icon-1.svg" alt="icono total pipeline" class="card-icon" />
                        <span class="card-title">Total Pipeline</span>
                        </div>
                        <div class="card-body">
                            <b class="card-amount-bold">${{formatAmountToMillions(totales?.total_pipeline)}}M</b> CLP
                        </div>
                    </div>
                </div>
            </div>

            <div class="forecast-graphic">
                <div class="chart-container">
                <div class="d-grid align-center" style="grid-template-columns: auto 1fr; align-items: center; gap: 10px;">
                    <img src="assets/svg/charts-icon.svg" alt="">
                    <h2 class="t-20 text-semibold">Cambios en el prónostico</h2>
                </div>
                <div class="org-hr mt-3" style="background-color: #EA5A10; min-height: 2px;"></div>
                    <canvas 
                        baseChart
                        [data]="chartData"
                        [options]="chartOptions"
                        [type]="'bar'"
                        style="width: 100% !important; max-width: 100%;"
                    >
                    </canvas>
                </div>
            </div>

            <div class="forecast prospectos-table mh-50 mt-5">
                <table>
                    <thead>
                        <tr class="header-forecast">
                            <th>Categoría de pronóstico</th>
                            @for (periodo of forecasts; track periodo) {
                                <th>{{ periodo.mes_largo }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Metas</td>
                            @for(montos of forecasts; track montos) {
                                <td>{{ montos.total_metas | currency:'CLP ':'symbol':'1.0-0' }}</td>
                            }
                        </tr>
                        <tr>
                            <td>Oportunidades cerradas</td>
                            @for(montos of forecasts; track montos) {
                                <td>{{ montos.cerradas_ganadas | currency:'CLP ':'symbol':'1.0-0' }}</td>
                            }
                        </tr>
                        <tr>
                            <td>Mejor de los casos</td>
                            @for(montos of forecasts; track montos) {
                                <td>{{ montos.alta_probabilidad | currency:'CLP ':'symbol':'1.0-0' }}</td>
                            }
                        </tr>
                        <tr>
                            <td>Oportunidades de baja probabilidad</td>
                            @for(montos of forecasts; track montos) {
                                <td>{{ montos.baja_probabilidad | currency:'CLP ':'symbol':'1.0-0' }}</td>
                            }
                        </tr>
                        <tr>
                            <td class="text-semibold">Total Pipeline</td>
                            @for(montos of forecasts; track montos) {
                                <td class="text-semibold">{{ montos.total_pipeline | currency:'CLP ':'symbol':'1.0-0' }}</td>
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
